import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { t } from "i18next";
import ApiUrls from "../../../../helpers/urls/ApiUrls";
import RouteUrls from "../../../../helpers/urls/RouteUrls";
import { appendFormData } from "../../../../helpers/functions/form-append";
import AddLayout from "../../../../components/AddLayout";
import AddDomainForm from "../../components/addForm";
import CustomDialog from "../../../../components/Dialog";

function AddDomain({ data, isEdit }) {
  const navigate = useNavigate();
  const [openDialog, setOpenDialog] = useState(false);
  const [formData, setFormData] = useState({
    domain: [""], // Domain(s)
    disabled: "1", // Is disabled?, Boolean 0/1 (default 0)
    srcip: "", // Source IP
    srcport: 80, // Source HTTP Port, Integer (default 80)
    srchttpsport: 443, // Source HTTPS Port, Integer (default 443)
    httpport: 80, // HTTP Port
    redirecthttp: "0", // Redirect to HTTPS? Boolean 0/1
    minuses: 1, // HTTP Minimum hits to store in cache, Integer
    prxvalidnum: 1, // HTTP Validity duration, Integer
    prxvalidunit: "h", // HTTP Validity duration number unit, String (s/m/h/d/w/M/y)
    ishttps: "0", // HTTPS active?, Boolean 0/1
    httpsport: 443, // HTTPS Port, Integer
    ishttp2: "1", // HTTP2 active? , Boolean 0/1
    sminuses: "", // HTTPS Minimum hits to store in cache, Integer
    sprxvalidnum: "", // HTTPS Validity duration, Integer
    sprxvalidunit: "h", // HTTPS Validity duration number unit, String (s/m/h/d/w/M/y)
    certmanaged: "1", // Certificates self-managed (0) or CDN managed (1)
    anycastip: ""
  });
  const {
    domain,
    srcip,
    srcport,
    srchttpsport,
    httpport,
    redirecthttp,
    minuses,
    prxvalidnum,
    prxvalidunit,
    ishttps,
    httpsport,
    sminuses,
    sprxvalidnum,
    sprxvalidunit,
    certmanaged,
    anycastip
  } = formData;

  const [errors, setErrors] = useState({});
  const [postFormData, setPostFormData] = useState(null);

  // used in edit pages
  useEffect(() => {
    if (data) {
      setFormData(data);
    }
  }, [data]);

  // check form validations
  const checkInputs = () => {
    let temp_errors = {};

    // domains validation
    const filteredDomain = domain.filter((d) => d !== "");
    if (filteredDomain.length === 0) {
      temp_errors.domain = { "0": t("message.required", { item: t("domain.domain_address") }) };
      filteredDomain.push("");
    }

    // source_ip validation
    if (srcip === "") {
      temp_errors.srcip = t("message.required", { item: t("domain.source_ip") });
    }

    // http_port validation
    if (httpport === "") {
      temp_errors.httpport = t("message.required", { item: t("domain.port") });
    }
    if (srcport === "") {
      temp_errors.srcport = t("message.required", { item: t("domain.http_src_port") });
    }
    if (anycastip === "") {
      temp_errors.anycastip = t("message.required", { item: t("site.anycast") });
    }

    // if redirecthttp is disabled check http inputs
    if (redirecthttp === "0") {
      if (minuses === "") {
        temp_errors.minuses = t("message.required", { item: t("domain.cache_num_request") });
      }
      if (prxvalidnum === "") {
        temp_errors.prxvalidnum = t("message.required", { item: t("domain.valid_time") });
      }
      if (prxvalidunit === "") {
        temp_errors.prxvalidunit = t("message.required", { item: t("domain.valid_time") });
      }
    }

    // check https's inputs if ishttps is enabled
    if (ishttps === "1") {
      if (httpsport === "") {
        temp_errors.httpsport = t("message.required", { item: t("domain.port") });
      }
      if (srchttpsport === "") {
        temp_errors.srchttpsport = t("message.required", { item: t("domain.https_src_port") });
      }
      if (sminuses === "") {
        temp_errors.sminuses = t("message.required", { item: t("domain.cache_num_request") });
      }
      if (sprxvalidnum === "") {
        temp_errors.sprxvalidnum = t("message.required", { item: t("domain.valid_time") });
      }
      if (sprxvalidunit === "") {
        temp_errors.sprxvalidunit = t("message.required", { item: t("domain.valid_time") });
      }
    }

    setFormData({
      ...formData,
      domain: filteredDomain,
    });
    setErrors(temp_errors);

    if (Object.keys(temp_errors).length === 0) {
      createPostFormData(filteredDomain);
    }
  }

  const createPostFormData = (filteredDomain) => {
    // transform domain array to string
    let postDomains = "";
    filteredDomain.map((domain, i) => {
      if (i !== filteredDomain.length) {
        postDomains += `${domain} `;
      } else {
        postDomains += domain;
      }
    });
    const tempFormData = formData;
    formData.domain = postDomains;
    if (isEdit) {
      formData.uid = data.id;
    }

    setPostFormData(appendFormData(tempFormData));
  }

  return (
    <>
      <AddLayout
        title={t("domain.domain")}
        addUrl={isEdit ? ApiUrls.domain.edit : ApiUrls.domain.add}
        listUrl={RouteUrls.domain.list}
        onClick={checkInputs}
        postFormData={postFormData}
        isEdit={isEdit}
        setOpenDialog={setOpenDialog}
      >
        <AddDomainForm
          formData={formData}
          setFormData={setFormData}
          errors={errors}
          setErrors={setErrors}
          isEdit={isEdit}
        />
      </AddLayout>

      <CustomDialog
        open={openDialog}
        title={t("domain.domain_add_dialogue_title")}
        text={
          <div>
            <div>
              <span className="ms-1">-</span>
              {t("domain.domain_add_dialogue_p1", { ip: formData?.anycastip} )}
            </div>
            {ishttps === "1" && certmanaged === "1"
              ? (
                <div className="mt-2">

                  <span className="ms-1">-</span>
                  {t("domain.domain_add_dialogue_p2")}
                </div>
              ) : null
            }
          </div>
        }
        onAccept={() => navigate(RouteUrls.domain.list)}
      />
    </>
  );
}

export default AddDomain;
